import type { ReactElement } from 'react'
import { useRequiredParams } from '@util'
import { isDefined, type WithAccountId } from '@terros/common'
import { createFileRoute } from '@tanstack/react-router'
import { useAccount } from '@front/model'
import { NotReady } from '@components'
import { WorkflowAccountForm } from './workflowForm/WorkflowAccountForm'
import { IncompleteAccountForm } from './legacyForm/IncompleteAccountForm'

function Account(): ReactElement {
  const { accountId } = useRequiredParams<WithAccountId>()
  const { data, isLoading, error, isFetching, refetch } = useAccount(accountId)

  if (isLoading || error || !data)
    return <NotReady data={data} error={error} id='Account' isLoading={isLoading || isFetching} />
  if (isDefined(data.workflowId))
    return <WorkflowAccountForm account={data} isFetching={isFetching} refetch={refetch} />
  if (isFetching) return <NotReady isLoading id='Account' />
  return <IncompleteAccountForm account={data} isFetching={isFetching} refetch={refetch} />
}

export const Route = createFileRoute('/account_/$accountId/')({
  component: Account,
})
